import { css } from "@emotion/react";

export const bannerWrapper = css`
  display: flex;
  justify-content: center;
`;

export const banner = css`
  flex: 1;
`;
